export default __webpack_public_path__ + "static/media/novelty.9d6eac56.png";